import React from "react";

import { CusButton } from "../From/Button";
import { FormattedMessage } from "react-intl";
import { Modal } from "reactstrap";

//內用特口ID
const STAY_IN_TASTE_ID = {
  湯麵分開: 74,
  湯麵合在一起: 86,
};

// 特口多國語系文字對應
const PRODUCT_TASTE_LANG_KEYS = {
  "1-009-01": {
    //元盅雞麵
    question: "popup.ChickenNoodlesSeparateOrNot", //是否將雞湯倒入麵碗中
    yes: "popup.ChickenNoodles.yes",
    no: "popup.ChickenNoodles.no",
  },
  "1-009-02": {
    //元盅牛肉麵
    question: "popup.BeefNoodlesSeparateOrNot", //是否將牛肉湯倒入麵碗中
    yes: "popup.BeefNoodles.yes",
    no: "popup.BeefNoodles.no",
  },
};

function Tool_ServeBeforeNoodleSoup({
  data,
  setDTvalue,
  DTvalue,
  hadleDT,
  setDTModel,
}) {
  let specificationData = data.specification.filter(
    (x) => x.combination[0].taste.length > 0
  );
  let selectedVal = null;
  if (specificationData.length > 0) {
    selectedVal = specificationData[0].combination[0].taste[0];
  }

  const questionText = PRODUCT_TASTE_LANG_KEYS[data.dtf_id] ? (
    <FormattedMessage id={PRODUCT_TASTE_LANG_KEYS[data.dtf_id].question} />
  ) : (
    "是否把湯倒入麵碗裡?"
  );

  const yesText = PRODUCT_TASTE_LANG_KEYS[data.dtf_id] ? (
    <FormattedMessage id={PRODUCT_TASTE_LANG_KEYS[data.dtf_id].yes} />
  ) : (
    "是"
  );

  const noText = PRODUCT_TASTE_LANG_KEYS[data.dtf_id] ? (
    <FormattedMessage id={PRODUCT_TASTE_LANG_KEYS[data.dtf_id].no} />
  ) : (
    "否"
  );

  return (
    <div>
      <Modal isOpen fade={false} backdrop={false}>
        <div className="Tool Tool__CusSp d-flex justify-content-center align-items-center ">
          <div className="Tool__CusSp__content d-flex flex-column h-75 justify-content-between p-5 position-relative min-h-400">
            <div className="d-flex flex-column position-absolute fixed-top p-4  my-2 h-100">
              <div className="Tool__CusSp__title">{questionText}</div>
              <hr className="" />
              <div className="h-100 ">
                <div className="w-100 d-flex flex-wrap justify-content-between">
                  <div
                    onClick={() => {
                      setDTvalue(STAY_IN_TASTE_ID.湯麵合在一起);
                    }}
                    className={
                      DTvalue === STAY_IN_TASTE_ID.湯麵合在一起
                        ? "need_button-on w-45"
                        : selectedVal === STAY_IN_TASTE_ID.湯麵合在一起
                        ? "need_button-selected w-45"
                        : "need_button w-45"
                    }
                  >
                    {yesText}
                  </div>
                  <div
                    onClick={() => {
                      setDTvalue(STAY_IN_TASTE_ID.湯麵分開);
                    }}
                    className={
                      DTvalue === STAY_IN_TASTE_ID.湯麵分開
                        ? "need_button-on w-45"
                        : selectedVal === STAY_IN_TASTE_ID.湯麵分開
                        ? "need_button-selected w-45"
                        : "need_button w-45"
                    }
                  >
                    {noText}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between m-0 p-4 position-absolute fixed-bottom bg-white">
              <div className="col-6 w-50 p-1">
                <CusButton.White
                  children={<FormattedMessage id="popup.buttonBack" />}
                  className="btn-block py-2"
                  onClick={() => {
                    setDTModel(false);
                  }}
                />
              </div>
              <div className="col-6  w-50 p-1">
                <CusButton.Red
                  children={<FormattedMessage id="popup.buttonConfirm" />}
                  className="btn-block py-2"
                  disabled={!DTvalue}
                  onClick={async () => {
                    try {
                      await hadleDT(DTvalue); // Wait for hadleDT to finish
                      setDTModel(false); // Set DTModel to false
                      // await saveOrderAndGoBack();
                    } catch (error) {
                      // Handle errors if any of the async functions fail
                      console.error("An error occurred:", error);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Tool_ServeBeforeNoodleSoup;
